import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, LogIn, X } from 'lucide-react';
import { LOGIN } from '../utils/navigation';
import './RateLimitModal.css';

interface RateLimitModalProps {
  message: string;
  retryAfter?: number;
  onClose: () => void;
}

const formatRetryAfter = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  if (hours > 0) {
    return `${hours}h${minutes > 0 ? ` ${minutes}min` : ''}`;
  }
  return `${minutes} min`;
};

const RateLimitModal: React.FC<RateLimitModalProps> = ({ message, retryAfter, onClose }) => {
  const navigate = useNavigate();

  const handleLogin = () => {
    onClose();
    window.location.href = 'https://datagreffe.ci/auth/login';
  };

  return (
    <div className="rate-limit-overlay" onClick={onClose}>
      <div className="rate-limit-modal" onClick={(e) => e.stopPropagation()}>
        <button className="rate-limit-close" onClick={onClose}>
          <X size={20} />
        </button>

        <div className="rate-limit-icon">
          <AlertTriangle size={48} />
        </div>

        <h2 className="rate-limit-title">Accès limité</h2>

        <p className="rate-limit-message">{message}</p>

        {retryAfter != null && retryAfter > 0 && (
          <p className="rate-limit-retry">
            Réessai possible dans <strong>{formatRetryAfter(retryAfter)}</strong>
          </p>
        )}

        <div className="rate-limit-actions">
          <button className="rate-limit-btn-login" onClick={handleLogin}>
            <LogIn size={18} />
            Se connecter
          </button>
          <button className="rate-limit-btn-close" onClick={onClose}>
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};

export default RateLimitModal;
